import React from 'react'
// libs
import styled from 'styled-components'
// components
import Checkbox from 'components/FormElements/Checkbox'
// utils
import { getOptionsForFilter } from 'utils/activities'
// context
import { ActivitiesListAPIContext } from 'containers/Activities/layers/API/ActivitiesList'
import { ActivitiesListBLContext } from 'containers/Activities/layers/BL/ActivitiesList'

// styled
const FilterWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 160px;

  label {
    padding: 0 5px 0 15px;
  }
`

const ActivityFilter: React.FC = () => {
  const { entity } = React.useContext(ActivitiesListAPIContext)
  const { filters, handleSetFilters } = React.useContext(ActivitiesListBLContext)

  const handleApplyFilter = (event) => {
    handleSetFilters({
      ...filters,
      [event.target.name]: event.target.checked
    })
  }

  return (
    <>
      <FilterWrapper>
        {getOptionsForFilter(entity.entityType).map((option) => (
          <Checkbox
            key={option.value}
            option={option}
            name={option.stateKey}
            checked={filters[option.stateKey]}
            onChange={handleApplyFilter}
          />
        ))}
      </FilterWrapper>
    </>
  )
}

export default ActivityFilter
